export default [
  /*** 院校 开始 ***/
  {
    path: '/college/list',
    component: () => import('../pages/base/college/index.vue'),
    meta: { title: '院校管理' }
  },
  {
    path: '/college/category',
    component: () => import('../pages/base/college/category.vue'),
    meta: { title: '院校分类管理' }
  },
  {
    path: '/college/:collegeId/major',
    component: () => import('../pages/base/collegeMajor/index.vue'),
    meta: { title: '院校专业列表' }
  },
  {
    path: '/college/:collegeId/academy',
    component: () => import('../pages/base/academy/index.vue'),
    meta: { title: '院校学院列表' }
  },
  {
    path: '/college/:collegeId/academy/:academyId/major',
    component: () => import('../pages/base/academyMajor/index.vue'),
    meta: { title: '院校学院专业列表' }
  },
  /*** 院校 结束 ***/

  /*** 专业 开始 ***/
  {
    path: '/major/list',
    component: () => import('../pages/base/major/index.vue'),
    meta: { title: '专业管理' }
  },
  {
    path: '/major/:majorId/subject',
    component: () => import('../pages/base/majorSubject/index.vue'),
    meta: { title: '专业科目列表' }
  },
  /*** 专业 结束 ***/

  /*** 科目 开始 ***/
  {
    path: '/subject/list',
    component: () => import('../pages/base/subject/index.vue'),
    meta: { title: '科目管理' }
  },
  {
    path: '/subject/category',
    component: () => import('../pages/base/subject/category.vue'),
    meta: { title: '科目分类管理' }
  },
  /*** 科目 结束 ***/

  /*** 教题 开始 ***/
  {
    path: '/teacher/list',
    component: () => import('../pages/base/teacher/index.vue'),
    meta: { title: '教题管理' }
  },
  /*** 教题 结束 ***/


  /*** 报考信息 开始 ***/
  {
    path: '/information/list',
    component: () => import('../pages/base/information/index.vue'),
    meta: { title: '报考信息' }
  },
  /*** 报考信息 结束 ***/

  /*** 录取信息 开始 ***/
 {
    path: '/admission/list',
    component: () => import('../pages/base/admission/index.vue'),
    meta: { title: '录取信息' }
  },

   /*** 录取信息 结束 ***/

  /*** 金牌客服 开始 ***/
  {
    path: '/service/list',
    component: () => import('../pages/base/service/index.vue'),
    meta: { title: '金牌客服' }
  },
  {
    path: '/service/edit/:serviceId',
    component: () => import('../pages/base/service/edit.vue'),
    meta: { title: '金牌客服编辑' }
  },
  {
    path: '/service/create',
    component: () => import('../pages/base/service/create.vue'),
    meta: { title: '金牌客服创建' }
  },
  /*** 金牌客服 结束 ***/
]
